export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'nav-icon icon-speedometer'
    },
    {
      name: 'Referral Dashboard',
      url: '/referral-dashboard',
      icon: 'nav-icon icon-speedometer'
    },
    {
      name: 'Free Quiz',
      url: '/quiz',
      icon: 'icon-pin'
    },
    {
      name: 'Question',
      url: '/question',
      icon: 'icon-question'
    },
    {
      name: 'Telegram Member',
      url: '/telegram-member',
      icon: 'icon-people'
    },
    {
      name: 'Users',
      url: '/member',
      icon: 'icon-user'
    },
    {
      name: 'Referral Links',
      url: '/referral',
      icon: 'icon-action-undo'
    },
    {
      name: 'Sms Activation',
      url: '/activation',
      icon: 'icon-action-undo'
    },
    {
      name: 'Broadcast',
      url: '/broadcast',
      icon: 'icon-paper-plane'
    },
    {
      name: 'Settings',
      url: '/settings',
      icon: 'icon-settings'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js